import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import { getMonthDateRange, listenMetabaseMessages } from "../../../utils/dateRange";


const MBDistributors = () => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    const { desde, hasta } = getMonthDateRange();

    const dashboardUrl = `https://minimalartco.metabaseapp.com/public/dashboard/94cb181a-e95a-42fd-9efd-1ec1e546d810?desde=${encodeURIComponent(desde)}&hasta=${encodeURIComponent(hasta)}`;
    setUrl(dashboardUrl);
  }, []);

  useEffect(() => {
    const cleanup = listenMetabaseMessages();
    return () => cleanup && cleanup();
  }, []);

  return (
    <React.Fragment>
      <Helmet title="Scorecard" />
      <Container fluid className="p-0 mco-fade-in">
        <Row>
          <Col lg="12" className="mt-2">
            {url && (<iframe
                src={url}
                frameborder="0"
                width="100%"
                height="3000"
                allowtransparency
              ></iframe>
            )}
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default MBDistributors;
